// src/pages/Pedido/Pagamento.js
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCartArrowDown, FaMoneyBill, FaCreditCard, FaMoneyCheckAlt } from "react-icons/fa";
import { QRCodeCanvas } from 'qrcode.react';
import { MdOutlineFoodBank, MdOutlinePix } from "react-icons/md";
import { useApi } from '../../hooks/useApi';
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import './Pagamento.css'; // Importar o arquivo CSS externo.
import MainContent from '../../components/Form/MainContent';
import { formatCurrency } from '../../utils/numberUtils';
import Modal from '../../components/Modal/Modal';
import { useAuth } from '../../contexts/AuthContext';
import { useCart } from '../../contexts/CartContext';
import { FaPix } from 'react-icons/fa6';
import ModalTroco from './ModalTroco';
import { calcularResumoDelivery, formatarPercentualDelivery } from '../../utils/DescontoDelivery';

const Pagamento = () => {  
  const { fetchData, postData } = useApi();
  const [taxaEntrega, setTaxaEntrega] = useState(0);  
  const [tipoEntrega, setTipoEntrega] = useState(null);
  const [pagamento, setPagamento] = useState(null);
  const [pagamentoError, setPagamentoError] = useState(false);
  const [modalMessage, setModalMessage] = useState(''); // Estado para mensagens de erro
  const [showCardModal, setShowCardModal] = useState(false); // Estado para o modal de cartão
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { removeCart, cartItemTotal } = useCart();  

  const [showPixModal, setShowPixModal] = useState(false);
  const [pixCode, setPixCode] = useState('');
  const [copied, setCopied] = useState(false);
  const [showPixChoiceModal, setShowPixChoiceModal] = useState(false);
  const [appDesconto, setAppDesconto] = useState(0);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [carregandoFormas, setCarregandoFormas] = useState(true);
  const [erroFormas, setErroFormas] = useState('');

  const [showTrocoModal, setShowTrocoModal] = useState(false);
  const [trocoPara, setTrocoPara] = useState(null);
  const [observacaoPedido, setObservacaoPedido] = useState('');
  const [cashbackSolicitado, setValorCashBack] = useState(0);

  const [nomeCliente, setNomeCliente] = useState(null);
  const [telefoneCliente, setTelefoneCliente] = useState(null);
  const [desabilitaBtn, setDesabilitaBtn] = useState(false);
  const pagamentoSectionRef = useRef(null);



  useEffect(() => {
    if (!isAuthenticated) {

      //Pega os dados salvados fixo
      setNomeCliente(localStorage.getItem('nomeClienteInput') || '');

      //Número BR não precisa ir DDI o backend já está tratando
      const savedCountryCode = localStorage.getItem('countryCodeInput') || '+55';
      const savedPhoneNumber = localStorage.getItem('telefoneClienteInput') || '';
      // Set phone number based on country code, omitting "+" when saving
      if (savedCountryCode === '+55') {
        setTelefoneCliente(savedPhoneNumber);
      } else {
        // Remove "+" from country code when saving
        const cleanCountryCode = savedCountryCode.startsWith('+') ? savedCountryCode.slice(1) : savedCountryCode;
        setTelefoneCliente(cleanCountryCode + savedPhoneNumber);
      }
    }  

    //const enderecoData = JSON.parse(localStorage.getItem('endereco'));
    const tipoEntregaData = JSON.parse(localStorage.getItem('tipoEntrega'));

    const valorCashBack = parseFloat(localStorage.getItem('valorCashBack') || '0');

    setValorCashBack(valorCashBack);

    // if (enderecoData !== null) {
    //   setEndereco(enderecoData);
    // }

    setTipoEntrega(tipoEntregaData);
    setObservacaoPedido(localStorage.getItem('pedidoObservacao') || '');
    //setTotalItem(parseFloat(localStorage.getItem('totalItem')));

    if (tipoEntregaData && tipoEntregaData.taxaEntrega) {
      setTaxaEntrega(tipoEntregaData.taxaEntrega);
    }
    
  }, []);

  const formaSelecionada = formasPagamento.find(forma => forma.id === pagamento);
  const resumo = calcularResumoDelivery(cartItemTotal, appDesconto, formaSelecionada?.descontoDelivery, taxaEntrega, cashbackSolicitado);
  const { valorDesconto, valorCashBack, valorTotal } = resumo;
  const formasCartao = formasPagamento.filter(forma => [3, 4].includes(forma.meioPag));

  const carregarFormas = async () => {
    setCarregandoFormas(true);
    setErroFormas('');
    try {
      const [formas, config] = await Promise.all([fetchData('/FormaPag/Delivery'), fetchData('/ConfigPedido')]);
      setFormasPagamento(formas);
      setAppDesconto(config.appDesconto || 0);
      setPagamento(atual => formas.some(forma => forma.id === atual) ? atual : null);
    } catch (error) {
      setErroFormas('Não foi possível carregar as formas de pagamento. Tente novamente.');
    } finally {
      setCarregandoFormas(false);
    }
  };

  useEffect(() => { carregarFormas(); }, []);

  useEffect(() => {
    if (trocoPara > 0 && trocoPara < valorTotal) setTrocoPara(null);
  }, [valorTotal, trocoPara]);

  const handleButtonClick = (forma) => {
    setPagamento(forma.id);
    setPagamentoError(false);
    setTrocoPara(null);
    setShowCardModal(false);
    if (forma.meioPag === 1 && tipoEntrega?.descricao === 'Delivery') setShowTrocoModal(true);
  };

    //console.log("Botao Type: "+buttonType);
        // ❌ Remover abertura de modal Pix
        //setShowPixChoiceModal(false);
        //setShowPixModal(false);
  const handleObservacaoPedidoChange = (event) => {
    const { value } = event.target;
    setObservacaoPedido(value);
    localStorage.setItem('pedidoObservacao', value);
  };

  const handleCheckout = async () => {
    if (!formaSelecionada || carregandoFormas || erroFormas) {
      setPagamentoError(true);
      pagamentoSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setDesabilitaBtn(true);

    localStorage.setItem('formaPagamento', pagamento);

    const cartData = JSON.parse(localStorage.getItem('cart'));
    if (cartData && Array.isArray(cartData)) {
      var itensPedido = cartData.map(item => ({
        produtoId: item.id,
        qtde: item.qtde,
        valorItem: item.valorItem,
        valorAdicional: item.valorAdicional,
        valorTotal: item.valorTotal,
        observacao: item.observacao,
        variacao: item.variacao,
        pedidoItemAdicionais: item.adicionaisSelecionados?.map(itemAd => ({
          adicionalId: itemAd.id,
          valor: itemAd.preco * item.qtde
        })) || [],
        pedidoItemConjuntos: item.pedidoItemConjuntos,
        apresentacaoId:item.apresentacaoId,
      }));
      //console.log('Itens Pedido:', itensPedido);
    }


    let distancia, latitude, longitude, auxEndereco;

    if (tipoEntrega && tipoEntrega.descricao !== "Retirada") {

      distancia = localStorage.getItem('distance');      

      const coordsString = localStorage.getItem('coordsDest');
      if (coordsString) [latitude, longitude] = coordsString.split(',');

      auxEndereco = localStorage.getItem('enderecoCliente');   
    }

    try {
      const pedido = {
        id: 0,
        clienteId:null,
        //statusPedido: { id: 1, descricao: "Realizado" },
        nomeCliente,
        telefoneCliente,
        enderecoCliente: auxEndereco,
        formaPagId: pagamento,
        //tipoEntrega: { id: tipoEntrega ? tipoEntrega.id : null, taxaEntrega: taxaEntrega },
        tipoEntregaId: tipoEntrega.id,
        valorItens: cartItemTotal,
        valorDesconto,
        valorCashBack,
        taxaEntrega: taxaEntrega,
        valorTotal: valorTotal,
        trocoPara: trocoPara,
        observacao: observacaoPedido.trim() || null,
        //endereco,
        dataHoraPrevisao: null,        
        pedidoItens: itensPedido,
        latitude,
        longitude,
        distancia,
        taxaEntregaBairroId: Number(localStorage.getItem('taxaEntregaBairroId')) || null
      };
      
      let response;
      if (isAuthenticated) {
        response = await postData('/PedidoDelivery', pedido);
      } else {
        response = await postData('/PedidoSemLoginDelivery', pedido);
      }

      //let configPedido;
      // try {
      //   configPedido = await fetchData('/ConfigPedido');        
      // } catch (error) {
      //   console.error('Erro ao obter configPedido:', error);
      //   setErrorMessage('Falha ao carregar os dados do configPedido.');
      // }

      //const whatsappUrl = handleEnviarPedido(response, configPedido.telefonePedido);
      //window.location.href = whatsappUrl;

      removeCart();      
      localStorage.removeItem('pedidoObservacao');
      localStorage.removeItem('valorCashBack');

      if (isAuthenticated) {
        navigate('/resumo-pedido/' + response.id);
      } else {
        //ajustar essa rotina para mostrar o resumo do pedido        
        //setModalMessage("✅ Seu pedido foi confirmado! 🚀 Acompanhe as atualizações pelo WhatsApp 📢📲");

        // Passar o objeto response completo como state
        navigate(response.tokenResumo
          ? `/resumo-pedido-sem-login/${encodeURIComponent(response.tokenResumo)}`
          : '/resumo-pedido-sem-login', { state: { pedido: response } });
      }
      setDesabilitaBtn(false);
    } catch (error) {
      console.error('Erro: ', error);
      setModalMessage(
        error?.response?.data?.message ||
        'Não foi possível confirmar o pedido. Verifique os itens e tente novamente.'
      );
      setDesabilitaBtn(false);
    }
  };

  const closeModal = () => setModalMessage('');
  const closeCardModal = () => setShowCardModal(false);

  return (
    <>
      <Header titulo="Finalizar Pedido" />
      <MainContent className="pagamento-main">
        <section className="pagamento-page">
        <div className="pagamento-flow">
        <div
          ref={pagamentoSectionRef}
          className={`pagamento-payment-selection ${pagamentoError ? 'pagamento-payment-error' : ''}`}
        >
          <div className="pagamento-section-heading">
            <span className="pagamento-section-marker" aria-hidden="true" />
            <div>
              <h2>Forma de pagamento</h2>
              <p>Escolha como prefere pagar o pedido.</p>
            </div>
          </div>
          {carregandoFormas && <p role="status">Carregando formas de pagamento...</p>}
          {erroFormas && <div role="alert"><p>{erroFormas}</p><button type="button" onClick={carregarFormas}>Tentar novamente</button></div>}
          {!carregandoFormas && !erroFormas && formasPagamento.length === 0 && <p role="status">Nenhuma forma de pagamento disponível.</p>}
          {!carregandoFormas && !erroFormas && <div className="pagamento-payment-buttons-container">
            {formasPagamento.filter(forma => [1, 17].includes(forma.meioPag)).map(forma => (
              <button key={forma.id} type="button" className={`pagamento-button ${pagamento === forma.id ? 'selected' : ''}`}
                onClick={() => handleButtonClick(forma)} aria-pressed={pagamento === forma.id}>
                {forma.meioPag === 1 ? <FaMoneyBill size={32} /> : <MdOutlinePix size={32} />}
                <span>{forma.descricao}</span>
                {forma.descontoDelivery > 0 && <span className="pagamento-desconto-selo">{formatarPercentualDelivery(forma.descontoDelivery)}% de desconto</span>}
              </button>
            ))}
            {formasCartao.length > 0 && <button type="button" className={`pagamento-button ${[3, 4].includes(formaSelecionada?.meioPag) ? 'selected' : ''}`}
              onClick={() => setShowCardModal(true)} aria-pressed={[3, 4].includes(formaSelecionada?.meioPag)}>
              <FaCreditCard size={32} /><span>{[3, 4].includes(formaSelecionada?.meioPag) ? formaSelecionada.descricao : 'Cartão'}</span>
              {[3, 4].includes(formaSelecionada?.meioPag) && formaSelecionada.descontoDelivery > 0
                ? <span className="pagamento-desconto-selo">{formatarPercentualDelivery(formaSelecionada.descontoDelivery)}% de desconto</span>
                : formasCartao.some(forma => forma.descontoDelivery > 0) && <small>Confira os descontos</small>}
            </button>}
          </div>}
          {pagamentoError && (
            <span className="pagamento-error-label">Informe uma forma de pagamento</span>
          )}
        </div>

        {/* ✅ Mensagem Pix */}
        {formaSelecionada?.meioPag === 17 && (
          <p className="pagamento-pix-message">
            <MdOutlinePix aria-hidden="true" />
            O código Pix estará disponível no resumo após confirmar o pedido.
          </p>
        )}

        <div className="pagamento-observacao-container">
          <div className="pagamento-section-heading">
            <span className="pagamento-section-marker" aria-hidden="true" />
            <div>
              <label className="pagamento-observacao-label" htmlFor="pedidoObservacao">
                Observação geral do pedido
              </label>
              <p>Inclua uma orientação importante para o estabelecimento.</p>
            </div>
          </div>
          <textarea
            id="pedidoObservacao"
            className="pagamento-observacao-input"
            value={observacaoPedido}
            onChange={handleObservacaoPedidoChange}
            placeholder="Ex.: retiro às 11:30, entregar na portaria etc..."
            rows={4}
            //maxLength={250}
          />
        </div>
        </div>


        <aside className="pagamento-total-container" aria-label="Resumo do pedido" aria-live="polite" aria-atomic="true">
          <div className="pagamento-summary-heading">
            <span>Resumo</span>
            <small>Última conferência</small>
          </div>
          <div className="pagamento-total-linha">
            <p className="pagamento-total-second">Pedido: </p>
            <p className="pagamento-total-second">{formatCurrency(cartItemTotal)}</p>
          </div>

          {resumo.descontoGeral > 0 && <div className="pagamento-total-linha pagamento-desconto-linha">
            <p className="pagamento-total-second">Desconto do app:</p><p className="pagamento-total-second">-{formatCurrency(resumo.descontoGeral)}</p>
          </div>}
          {resumo.descontoPagamento > 0 && <div className="pagamento-total-linha pagamento-desconto-linha">
            <p className="pagamento-total-second">Desconto · {formaSelecionada?.descricao} ({formatarPercentualDelivery(formaSelecionada?.descontoDelivery)}%):</p>
            <p className="pagamento-total-second">-{formatCurrency(resumo.descontoPagamento)}</p>
          </div>}
          {formaSelecionada?.descontoDelivery > 0 && <p className="pagamento-desconto-ajuda">Desconto sobre os itens. A taxa de entrega permanece integral.</p>}

          {valorCashBack > 0 && (
          <div className="pagamento-total-linha">
            <p className="pagamento-total-second">CashBack: </p>
            <p className="pagamento-total-second">-{formatCurrency(valorCashBack)}</p>
          </div>)}

          {taxaEntrega > 0 && (
          <div className="pagamento-total-linha">
            <p className="pagamento-total-second">Taxa de Entrega: </p>
            <p className="pagamento-total-second">{formatCurrency(taxaEntrega)}</p>
          </div>
          )}

          {trocoPara > 0 && (
          <div className="pagamento-total-linha">
            <p className="pagamento-total-second">Troco para: </p>
            <p className="pagamento-total-second">{formatCurrency(trocoPara)}</p>
          </div>
          )}

          <div className="pagamento-total-linha">
            <p className="pagamento-total-title">Total a Pagar: </p>
            <p className="pagamento-total-title">{formatCurrency(valorTotal)}</p>
          </div>
          
          <button
            className="pagamento-checkout-button"
            disabled={desabilitaBtn || carregandoFormas || !!erroFormas || !formaSelecionada}
            onClick={handleCheckout}
          >
            {desabilitaBtn ? 'Enviando pedido...' : 'Confirmar Pedido'} <FaCartArrowDown />
          </button>
        </aside>
        </section>
      </MainContent>

      {/* Modal para mensagens de erro */}
      <Modal
        show={!!modalMessage}
        onClose={closeModal}
        message={modalMessage}
      />

      {/* Modal para escolha de Débito ou Crédito */}
      <Modal
        show={showCardModal}
        onClose={closeCardModal}
        message="Escolha o modo de pagamento:"
      >
        <div className="pagamento-card-options">
          {formasCartao.map(forma => <button key={forma.id} type="button" className="pagamento-card-option"
            onClick={() => handleButtonClick(forma)} aria-pressed={pagamento === forma.id}>
            <span className="pagamento-card-option-icon" aria-hidden="true">{forma.meioPag === 4 ? <FaMoneyCheckAlt /> : <FaCreditCard />}</span>
            <span className="pagamento-card-option-content"><strong>{forma.descricao}</strong><small>{forma.meioPag === 4 ? 'Débito' : 'Crédito'}</small>
              {forma.descontoDelivery > 0 && <span className="pagamento-desconto-selo">{formatarPercentualDelivery(forma.descontoDelivery)}% de desconto</span>}
            </span>
          </button>)}
        </div>
      </Modal>

      <Modal
        show={showPixChoiceModal}
        onClose={() => setShowPixChoiceModal(false)}
        message="Escolha como deseja pagar com Pix:"
      >
        <div className="pagamento-pix-choice">
          <p>
            Você pode pagar agora escaneando o QR Code Pix ou optar por pagar na retirada.
          </p>
          <div className="pagamento-pix-actions">
            <button
              type="button"
              className="pagamento-modal-action pagamento-modal-action-primary"
              onClick={async () => {
                setPagamento(formaSelecionada?.id);
                setShowPixChoiceModal(false);
                try {
                  const response = await fetchData(`/Pix?valor=${valorTotal}`);
                  setPixCode(response);
                  setShowPixModal(true);
                } catch (error) {
                  console.error('Erro ao gerar Pix:', error);
                  setModalMessage('Erro ao gerar código Pix.');
                }
              }}
            >
              Gerar Pix <FaPix />
            </button>
            <button
              type="button"
              className="pagamento-modal-action pagamento-modal-action-secondary"
              onClick={() => {
                setPagamento(formaSelecionada?.id);
                setShowPixChoiceModal(false);
              }}
            >
              Pagar na Retirada <MdOutlineFoodBank />
            </button>
          </div>
        </div>
      </Modal>


      <Modal show={showPixModal} onClose={() => setShowPixModal(false)} message="Escaneie o QR Code Pix para pagar:">
        <div className="pagamento-pix-code">
          {pixCode && (
            <>
              <div className="pagamento-qr-wrapper">
                <QRCodeCanvas value={pixCode} size={256} />
              </div>
              <p className="pagamento-pix-copy-code">
                {pixCode}
              </p>

              {copied && (
                <p className="pagamento-copy-feedback" role="status">
                  QR Code copiado!
                </p>
              )}

              <div className="pagamento-pix-actions">
                <button
                  type="button"
                  className="pagamento-modal-action pagamento-modal-action-primary"
                  onClick={() => {
                    navigator.clipboard.writeText(pixCode);
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                      setShowPixModal(false);
                    }, 1000);
                  }}
                >
                  Copiar Código
                </button>
                <button
                  type="button"
                  className="pagamento-modal-action pagamento-modal-action-danger"
                  onClick={() => setShowPixModal(false)}
                >
                  Fechar
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>
      <ModalTroco
        show={showTrocoModal}
        onClose={() => setShowTrocoModal(false)}
        valorTotal={valorTotal}
        onSelecionarTroco={(valor) => setTrocoPara(valor)}
      />
      <Footer />
    </>
  );
};

export default Pagamento;
